import React, { Component } from 'react';
import { HtmlContent } from '..';
import './AboutTextCol.scss';

class AboutTextCol extends Component {
  render() {
    const {
      isMobile,
      aboutTitle,
      biography,
      approachTitle,
      approachDescription,
    } = this.props;
    return (
      <div className="col col-right text-col">
        <div className="bio-container">
          <h1 className="title">{aboutTitle.text}</h1>
          <div className="text-body">
            <HtmlContent content={biography.html} />
          </div>
        </div>
        <div className="approach-container">
          <h2 className="title">{approachTitle.text}</h2>
          <div className="text-body">
            <HtmlContent content={approachDescription.html} />
          </div>
        </div>
        {!isMobile && (
          <div className="cta-container">
            <span className="title">Some of my personal favourites</span>
            <svg className="arrow-icon" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.835 6.673h16.97a.85.85 0 0 1 0 1.7H2.877l4.89 5.193c.211.223.285.54.193.832a.864.864 0 0 1-.638.58.882.882 0 0 1-.833-.251L.23 8.08a.844.844 0 0 1-.228-.532.842.842 0 0 1 .228-.628L6.49.273a.882.882 0 0 1 .833-.252c.303.068.547.29.638.58a.841.841 0 0 1-.194.833L2.835 6.673z" fillRule="evenodd" />
            </svg>
          </div>
        )}
      </div>
    );
  }
}

export default AboutTextCol;
